import { Params } from "react-router-dom";
import client from "./axios";
import { User } from "../models/User";

const doctorsUrl = `${window.__env.BASE_URL}/doctors`;

export const Doctors = {
    getDoctors: (params?: URLSearchParams) => client.get<any>(doctorsUrl, { params }),
    getDoctor: (id: string) => client.get<User>(`${doctorsUrl}/${id}`),
    createDoctors: (user: User) => client.post<User>(doctorsUrl, user),
    updateDoctors: (user: Partial<User>) => client.put<User>(`${doctorsUrl}/${user.id}`, user),
    deleteDoctor: (id: number) => client.delete<User>(`${doctorsUrl}/${id}`),
}